
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const CYCLES_OPTIONS = {
  '1': '1',
  '2': '2',
  regular: '1',
  irregular: '2',
};

const normalizeGinecologiaData = (dataItems) => {
  if (!dataItems) return dataItems;

  const normalizedData = { ...dataItems };
  const ciclosValue = normalizedData.ciclos;

  if (ciclosValue === null || ciclosValue === undefined || ciclosValue === '') {
    normalizedData.ciclos = '';
    return normalizedData;
  }

  const normalizedCycle = CYCLES_OPTIONS[String(ciclosValue).trim().toLowerCase()];
  normalizedData.ciclos = normalizedCycle || '';

  return normalizedData;
};

const registerAntecedentes = async (tokenAtencion, dataGineco) => {

  if(!tokenAtencion || !dataGineco){
    return null;
  }

  const query = `
    mutation CrearAntencionGinecologica(
      $tokenAtencion:ID!
      $dataItems:String!
    ) {
      CrearAntencionGinecologica(
        dataItems: $dataItems
        tokenAtencion: $tokenAtencion
      ) {
        message
        status
        ginecologia {
          id
          token
        }
      }
    }
  `;


  const variables = {
    tokenAtencion,
    dataItems: dataGineco,
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.CrearAntencionGinecologica;
    if(response2.status !== 'success') return null;

    const data = response2.ginecologia;
    return data;

  }catch(e){
    console.error('error', e)
    return null;
  }
}


const getAntecedentesByAtencion = async (tokenAtencion) => {

  if(!tokenAtencion){
    return null;
  }

  const query = `
    query GetAntecedentesGinecologicosAtencion(
      $tokenAtencion:String!
    ) {
      getAntecedentesGinecologicosAtencion(
        tokenAtencion: $tokenAtencion
      ) {
        status
        message
        ginecologicos {
          id
          token
          dataItems
        }
      }
    }
  `;

  const variables = {
    tokenAtencion
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.getAntecedentesGinecologicosAtencion;
    if(response2.status !== 'success') return null;

    const data = response2.ginecologicos[0];

    if(!data) return null;
    
    const dataMap = {
      ...data,
      dataItems: data.dataItems ? normalizeGinecologiaData(JSON.parse(data.dataItems)) : null,
    };

    return dataMap;

  }catch(e){
    console.error('error', e)
    return null;
  }
}


const updateAntecedentesByToken = async (tokenAntecedentes, dataGineco) => {

  if(!tokenAntecedentes || !dataGineco){
    return null;
  }

  const query = `
    mutation UpdateAntecedentesGinecologia(
      $tokenAntecedentes:String!
      $dataItems: String!
    ) {
      updateAntecedentesGinecologia(
        tokenAntecedentes: $tokenAntecedentes
        dataItems: $dataItems
      ) {
        message
        status
        ginecologia {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenAntecedentes,
    dataItems: dataGineco.dataItems,
    formOpt12: dataGineco.formOpt12,
    analisis: dataGineco.analisis
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    
    const response2 = response.data.data.updateAntecedentesGinecologia;
    if(response2.status !== 'success') return null;

    const data = response2.ginecologia;
    return data;

  }catch(e){
    console.error('error', e)
    return null;
  }
}



export const ginecologiaService = {
  registerAntecedentes,
  getAntecedentesByAtencion,
  updateAntecedentesByToken
}
